// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3CgIA","notes":"Notes_notes__3u2oz"};